import { makeStyles } from "@material-ui/core/styles";

export const PagesStyles = makeStyles(theme => ({
  pageContainer: {
    minHeight: "calc(100vh - 321px)"
  }
}));
